/** @format */

import { useQuery } from '@tanstack/react-query';

const fetchProfilePhoto = async (): Promise<string | null> => {
  const response = await fetch('/api/me/photo');
  if (!response.ok) return null;
  const blob = await response.blob();
  return URL.createObjectURL(blob);
};

export const useProfilePhoto = () => {
  const { data: photoUrl } = useQuery({
    queryKey: ['me', 'photo'],
    queryFn: fetchProfilePhoto,
    staleTime: 1000 * 60 * 60, // 1 hour — matches Cache-Control on the route
    retry: false,
  });

  return photoUrl ?? null;
};

export default useProfilePhoto;
